// Tabs: a [data-tabs] wrapper with [data-tab] buttons and matching [data-tab-panel] panels.
// Selecting a tab marks it aria-selected and shows only its panel. Tab sets can
// nest (the landing's use cases hold step tabs): each set only touches its own.
export function selectTab(tab: HTMLElement) {
  const tabs = tab.closest('[data-tabs]')
  if (!tabs) return
  const own = <T extends Element>(el: T) => el.closest('[data-tabs]') === tabs
  tabs.querySelectorAll<HTMLElement>('[data-tab]').forEach((t) => own(t) && t.setAttribute('aria-selected', String(t === tab)))
  tabs.querySelectorAll<HTMLElement>('[data-tab-panel]').forEach((panel) => {
    if (own(panel)) panel.hidden = panel.dataset.tabPanel !== tab.dataset.tab
  })
}

// Delegated click handler for every tab set on the page.
export function bindTabs(root: Document | HTMLElement = document) {
  root.addEventListener('click', (event) => {
    const tab = (event.target as Element).closest<HTMLElement>('[data-tab]')
    if (tab) selectTab(tab)
  })
}

// Opens the tab a link points at: #<tab id>, or #<id> of an element inside a panel
// (a prompt on the library's Prompts tab), so /app/library#tools lands on that tab.
export function selectFromHash(hash: string, root: Document = document) {
  const id = decodeURIComponent(hash.replace(/^#/, ''))
  if (!id) return
  const tab = Array.from(root.querySelectorAll<HTMLElement>('[data-tab]')).find((t) => t.dataset.tab === id)
  if (tab) return selectTab(tab)
  const panel = root.getElementById(id)?.closest<HTMLElement>('[data-tab-panel]')
  const owner = panel && panel.closest('[data-tabs]')?.querySelector<HTMLElement>(`[data-tab="${panel.dataset.tabPanel}"]`)
  if (owner) selectTab(owner)
}
